import {
  ProductPostedDate,
  ProductReportButton,
  ProductTags,
} from '@/components/molecules';
import { HttpTypes } from '@medusajs/types';

export const ProductDetailsFooter = ({
  tags = [],
  posted,
}: {
  tags?: HttpTypes.StoreProductTag[];
  posted: HttpTypes.StoreProduct['created_at'];
}) => {
  return (
    <>
      <div className='border-t border-gray-200 pt-4'>
        <ProductTags tags={tags} />
        <div className='flex justify-between items-center'>
          <ProductPostedDate posted={posted} />
          {/* <ProductReportButton /> */}
        </div>
      </div>
    </>
  );
};
